// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import facets from './facets';
import partReturns from './part-returns';
import searchFilters from './search-filters';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    facets,
    partReturns,
    searchFilters
});



// WEBPACK FOOTER //
// ./src/part-requests/all-parts-requests/reducers/index.js